import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Title = styled.h2`
  font-style: normal;
  font-weight: 400;
  font-size: 1.5rem;
  color: #40433e;
  margin-bottom: 1rem;
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 2rem;
`;
